import React from "react";
import { Hexagon as Hex } from "react-honeycomb-v2";
import Tile from "../../types/tile";
import { Box } from "@mui/material";
import TileBase from "../views/Tile/TileBase";

interface Props {
  tile: Tile;
}

const Hexagon: React.FC<Props> = (props) => {
  const { tile } = props;

  return (
    <Hex
      style={{
        position: "relative",
        margin: "0",
        display: "inline-block",
        animation: "test 1s ease",
      }}
    >
      <>
        <style>
          {`
          @keyframes test {
            0% { transform: scale(0); }
            100% { transform: scale(1); }
          }
        `}
        </style>
        <Box display="flex" flexDirection="row" height="100%" width="100%">
          <TileBase tile={tile} />
        </Box>
      </>
    </Hex>
  );
};

export default Hexagon;
